import YieldCurveVisualizer from './YieldCurveVisualizer';

export default function YieldCurveDemo() {
  return <YieldCurveVisualizer />;
}
